<template>
	<main class="layout-auth container">
		<slot />
	</main>
</template>
